module.exports = __webpack_public_path__ + "static/media/livestream.181d3170.svg";